import { useEffect, useState } from "react";
import { CalendarDays, CalendarOff, ChevronDown, Home, SunDim } from "lucide-react";
import { api } from "../../connect/api";

const ICON = { holiday: CalendarOff, half_holiday: SunDim, wfh: Home };
const TONE = { holiday: "text-amber-300 border-amber-500/40 bg-amber-500/10", half_holiday: "text-orange-300 border-orange-500/40 bg-orange-500/10", wfh: "text-emerald-300 border-emerald-500/40 bg-emerald-500/10" };
const day = (d) => new Date(`${d}T00:00:00`).toLocaleDateString("en-IN", { day: "2-digit", month: "short" });

/** Connect home card: upcoming holidays, half-day holidays and WFH days (company-wide + declared for this staff member). */
export const UpcomingDays = () => {
  const [items, setItems] = useState(null);
  const [all, setAll] = useState(false);
  useEffect(() => { api.get("/declarations").then((r) => setItems(r.data.items || [])).catch(() => setItems([])); }, []);
  if (!items || items.length === 0) return null;
  const shown = all ? items : items.slice(0, 3);
  return (
    <div className="mx-3 mt-3 rounded-2xl border border-white/10 bg-white/[0.03] p-3.5 nxc-fade-in" data-testid="upcoming-days-card">
      <div className="flex items-center gap-2 text-[11px] uppercase tracking-[0.18em] text-slate-400"><CalendarDays size={13} className="text-nx-goldlight" /> Upcoming holidays &amp; WFH</div>
      <ul className="mt-2.5 flex flex-col gap-2">
        {shown.map((it) => { const I = ICON[it.kind] || CalendarDays; return (
          <li key={`${it.date}-${it.kind}`} className="flex items-start gap-3" data-testid={`upcoming-${it.kind}-${it.date}`}>
            <div className={`shrink-0 w-16 text-center rounded-lg border px-1 py-1 whitespace-nowrap ${TONE[it.kind] || ""}`}>
              <div className="text-sm font-semibold leading-tight">{day(it.date)}</div>
              <div className="text-[10px] uppercase tracking-wide opacity-80">{it.today ? "Today" : it.weekday.slice(0, 3)}</div>
            </div>
            <div className="min-w-0 flex-1">
              <div className="text-sm text-slate-100 flex items-center gap-1.5"><I size={13} className="shrink-0 opacity-80" /> <span className="truncate">{it.label}</span></div>
              {it.reason && <div className="text-xs text-slate-400 truncate">{it.reason}</div>}
              {it.kind === "wfh" && <div className="text-[11px] text-emerald-300/80">Check In / Check Out from this screen on the day</div>}
              {it.kind === "half_holiday" && <div className="text-[11px] text-orange-300/80">Half day off · attend the working half as usual</div>}
            </div>
          </li>
        ); })}
      </ul>
      {items.length > 3 && (
        <button onClick={() => setAll((v) => !v)} className="mt-2.5 w-full text-[11px] uppercase tracking-wider text-slate-400 hover:text-white inline-flex items-center justify-center gap-1" data-testid="upcoming-toggle">
          {all ? "Show less" : `Show all ${items.length}`} <ChevronDown size={12} className={`transition-transform ${all ? "rotate-180" : ""}`} />
        </button>
      )}
    </div>
  );
};
